import styled, { css } from "styled-components";

export const Header = styled.header`
  width: 100%;
  display: flex;
  justify-content: end;

  position: fixed;
  z-index: 9999;

  @media (max-width: 767px) {
    background-color: ${(props) => props.theme.Light};
    width: calc(100% - 20px);
    height: 70px;
    padding: 20px 10px 0 10px;
    bottom: 0;
    box-shadow: 0px -5px 5px rgba(0, 0, 0, 0.3);
    justify-content: space-between;
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 4%,
      rgba(0, 0, 0, 0.2) 40%,
      rgba(0, 0, 0, 0.4) 88%
    );
    width: calc(100% - 40px);
    height: 50px;
    padding: 10px 20px;
    top: 0;
    gap: 150px;
    align-items: center;
  }
`;
